//create random key variable
const randomKey = Math.floor(Math.random() * 10**12).toString(36)

export const takeTheSoundLock = () => {
    if (localStorage.getItem("tabKey") !== randomKey) {
        localStorage.setItem("tabKey", randomKey);
    }
}

// //set key if it does not exist
// if (localStorage.getItem("tabKey") === null) {
//     localStorage.setItem("tabKey", randomKey);
// }

//when main tab closes, remove item from localStorage
window.addEventListener("unload", function () {
    if (localStorage.getItem("tabKey") === randomKey) {
        localStorage.removeItem("tabKey");
    }
});

//when non-main tabs receive the "close" event,
//the first one will set the `tabKey` to its `randomKey`
window.addEventListener("storage", function(evt) {
    if (evt.key === "tabKey" && evt.newValue === null) {
        if (localStorage.getItem("tabKey") === null) {
            localStorage.setItem("tabKey", randomKey);
        }
    }
});

// Singleton pattern for AudioContext
let audioContext;

const getAudioContext = () => {
    if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioContext;
};

export const initialPlay = () => {
    const audioContext = getAudioContext();
    const bufferSource = audioContext.createBufferSource();
    bufferSource.connect(audioContext.destination);
    if (typeof bufferSource.start === 'function') {
        bufferSource.start(0);
    }
    if (typeof bufferSource.stop === 'function') {
        bufferSource.stop(0);
    }
};

// we need to handle multiple execution
export const playSound = (soundUrl, volume = 0.2, repeatCount = 1, delay = 100, always = false) => {
    if (!always && localStorage.getItem("tabKey") !== randomKey) return;

    const audioContext = getAudioContext();
    fetch(soundUrl)
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => audioContext.decodeAudioData(arrayBuffer))
        .then(audioBuffer => {
            const playBuffer = () => {
                const soundSource = audioContext.createBufferSource();
                soundSource.buffer = audioBuffer;
                const gainNode = audioContext.createGain();
                gainNode.gain.value = volume;
                soundSource.connect(gainNode);
                gainNode.connect(audioContext.destination);

                soundSource.start();
                soundSource.onended = () => {
                    if (--repeatCount > 0) {
                        setTimeout(() => playBuffer(), delay)
                    }
                };
            };
            playBuffer(); // Initial call to play the buffer
        })
        .catch(error => console.error('Error playing the sound:', error));
};